import { createFileRoute } from '@tanstack/react-router';

import { ProposalPage } from '../../../../features/proposals/ui/proposal-page.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/deals/$id_/proposal')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: ProposalRoute,
});

/** КП сделки на всю страницу: `/sales/deals/<id>/proposal`. */
function ProposalRoute() {
  const { id } = Route.useParams();
  return <ProposalPage dealId={id} />;
}
